export const APP_TITLE = 'brewlytics';

export function setPageTitle(name: string | null | undefined): void {
  document.title = name ? `${name} — ${APP_TITLE}` : APP_TITLE;
}

// Ordered most-specific-first; first prefix match wins.
const TITLE_RULES: Array<[string, string]> = [
  ['/login', 'Login'],
  ['/authorized', 'Authorizing'],
  ['/external', 'Redirecting'],

  ['/dashboard/discover', 'Discover'],
  ['/dashboard', 'Dashboard'],

  ['/build', 'Model Builder'],
  ['/viz', 'Visualizations'],
  ['/brewdb', 'brewDB'],
  ['/search', 'Search'],

  ['/learn/help/functionals', 'Functional Reference'],
  ['/learn', 'Learn'],

  ['/develop/publish', 'Publish'],
  ['/develop/view', 'JAR Viewer'],
  ['/develop', 'Develop'],

  ['/users/profile', 'Profile'],
  ['/users/resource', 'Resource'],

  ['/tasks', 'Task'],

  ['/groups', 'Groups'],

  ['/admin/dashboard', 'Admin · Dashboard'],
  ['/admin/configurations', 'Admin · Configurations'],
  ['/admin/profiles', 'Admin · Profiles'],
  ['/admin/models', 'Admin · Models'],
  ['/admin/logs', 'Admin · Logs'],
  ['/admin/resources', 'Admin · Resources'],
  ['/admin/jobs', 'Admin · Jobs'],
  ['/admin/tasks', 'Admin · Tasks'],
  ['/admin/search', 'Admin · Search'],
  ['/admin/setup', 'Admin · Setup'],
  ['/admin', 'Admin'],

  ['/table-viewer', 'Table'],

  ['/401', 'Unauthorized'],
  ['/403', 'Forbidden'],
  ['/404', 'Not Found'],
  ['/500', 'Server Error'],
  ['/503', 'Service Unavailable'],
];

export function titleForPath(pathname: string): string | null {
  for (const [prefix, title] of TITLE_RULES) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) return title;
  }
  return null;
}
